module.exports = __webpack_public_path__ + "img/0-2.e3f70426.jpg";